import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllCohortManagementDataService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    return axios.get(
      `${api}/Cohort/GetCohortDataPagination?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const createCohortService = async (access_token, data) => {
  try {
    return axios.post(`${api}/Cohort/AddCohort`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchCohortByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/Cohort/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateCohortService = async (access_token, data) => {
  try {
    return axios.post(`${api}/Cohort/UpdateCohort`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
